import { Box as BoxMui } from "@mui/material";

const Box = ({ children, sx, ...rest }) => {
  return (
    <BoxMui sx={sx} {...rest}>
      {children}
    </BoxMui>
  );
};

export default Box;
